
    Date.prototype.toTimeString = function () {
        var szHour, szMinute;
        szHour = this.getHours().toString();
        szMinute = this.getMinutes().toString();
        return szHour.padl(2) + ":" + szMinute.padl(2);
    };

    /**
     * Return date as string in format DDD / yyyy-MM-dd (result from toDateString)
     * @returns {string}
     */
    Date.prototype.toFullDateString = function () {
        var dayOfWeek, result;
        dayOfWeek = this.getDay();
        result = Date.getDayName(dayOfWeek) + " / " + this.toDateString();
        return result;
    };
    String.prototype.toEnglishDate = function(){
        let val = this;
        for(let day of ["Senin::Monday", "Selasa::Tuesday", "Rabu::Wednesday", "Kamis::Thursday", "Jumat::Friday", "Sabtu::Saturday", "Minggu::Sunday"]){
            let dayS = day.split("::");
            val = val.replace(dayS[0], dayS[1]);
        }
        return val;
    }

    /**
     * Return date as string in yyyy-MM-dd
     * @returns {string}
     */
    Date.toDateString = function (date, format, defaultValue) {
        if (jng.isUndefined(date)) {
            return jng.coalesce(defaultValue, '');
        }
        let curDate = date
        if (!jng.isDate(date)) {
            curDate = new Date(date)
        }
        if (!jng.isDate(curDate)) {
            return jng.coalesce(defaultValue, '');
        }
        if (Date.isDefaultDate(curDate)) {
            return jng.coalesce(defaultValue, '');
        }
        var szDate, szYear, szMonth, szResult;
        szDate = curDate.getDate().toString();
        szYear = curDate.getFullYear().toString();
        szMonth = (curDate.getMonth() + 1).toString();
        if(jng.isUndefined(format)){
            szResult = szYear + "-" + szMonth.padl(2) + "-" + szDate.padl(2);
        }else if(format === 'dd-mm-yyyy' || format === 'dd-MM-yyyy' ){
            szResult = szDate.padl(2) + "-" + szMonth.padl(2) + "-" + szYear;
        }else if(format === 'dd/mm/yyyy' || format === 'dd/MM/yyyy' ){
            szResult = szDate.padl(2) + "/" + szMonth.padl(2) + "/" + szYear;
        }else if (format === 'dd MMMM yyyy') {
            szResult = szDate.padl(2) + " " + curDate.getMonthName() + " " + szYear;
        }
        return szResult;
    };

    Date.toDateFullEnglishString = function (date) {
        if (jng.isUndefined(date)) {
            return '';
        }
        var szDate, szYear, szMonth, szResult;
        szDate = date.getDate().toString();
        szYear = date.getFullYear().toString();
        szResult = Date.getMonthNameInEnglish(date.getMonth() + 1) + ' ' + szDate.padl(2) + ", " + szYear;
        return szResult;
    };

    Date.toDateFullEnglishString2ndFormat = function (date) {
        if (jng.isUndefined(date)) {
            return '';
        }
        var szDate, szYear, szMonth, szResult;
        szDate = date.getDate().toString();
        szYear = date.getFullYear().toString();
        szResult = szDate.padl(2) + ' ' + Date.getMonthNameInEnglish(date.getMonth() + 1) + " " + szYear;
        return szResult;
    };

    Date.prototype.toDateString = function (format) {
        return Date.toDateString(this, format);
    };

    Date.prototype.toDateMonthString = function () {
        var szDate, szMonth, szResult;
        szDate = this.getDate().toString();
        szMonth = (this.getMonth() + 1).toString();
        szResult = szMonth.padl(2) + "/" + szDate.padl(2);
        return szResult;
    };

    Date.prototype.yearMonthName = function () {
        return this.getFullYear() + ' ' + this.getAbbrMonthName();
    };

    Date.prototype.yearMonth = function () {
        return this.getFullYear() + '' +  (this.getMonth() + 1).toString().padl(2);
    };
    
    /**
     * Return date as string in yyyy-MM-dd HH:mm:ss
     * @returns {string}
     */
    Date.prototype.toDateTimeString = function (bNumericVersion) {
        var monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var szDate, szYear, szResult, szHour, szMinute, szSecond;
        szDate = this.getDate().toString();
        szYear = this.getFullYear().toString();
        szHour = this.getHours().toString();
        szMinute = this.getMinutes().toString();
        szSecond = this.getSeconds().toString();

        if (jng.isUndefined(bNumericVersion)) {
            bNumericVersion = false;
        }

        if (bNumericVersion) {
            var szMonth = (this.getMonth() + 1).toString();
            szResult = szYear + "-" + szMonth.padl(2) + "-" + szDate.padl(2) + " " + szHour.padl(2) + ":" + szMinute.padl(2) + ":" + szSecond.padl(2);
        } else {
            szResult = monthName[this.getMonth()] + " " + szDate.padl(2) + ", " + szYear + " " + szHour.padl(2) + ":" + szMinute.padl(2) + ":" + szSecond.padl(2);
        }
        return szResult;
    };

/**
     * Return week of year.
     * @returns {int}
     */
 Date.prototype.getWeek = function () {
    var oneJan;
    oneJan = new Date(this.getFullYear(), 0, 1);
    return Math.ceil((((this - oneJan) / 86400000) + oneJan.getDay() + 1) / 7);
};

/**
 * Add / subtract day to current date (change this object) and return it.
 * @param {int} dayNumber. Positive to add and negative to minus
 * @returns {Date}
 */
Date.prototype.addDay = function (dayNumber) {
    this.setDate(this.getDate() + dayNumber);
    return this;
};

/**
 * Add / subtract month to current date (change this object) and return it.
 * @param {int} monthNumber. Positive to add and negative to minus
 * @param {int} monthNumber. Positive to add and negative to minus
 * @returns {Date}
 */
Date.prototype.addMonth = function (monthNumber) {
    this.setMonth(this.getMonth() + Number(monthNumber));
    return this;
};

/**
 * Add / subtract month to current date (change this object) and return it.
 * @param {int} monthNumber. Positive to add and negative to minus
 * @param {int} monthNumber. Positive to add and negative to minus
 * @returns {Date}
 */
 Date.prototype.addTime = function (hour, minute, second) {
    let inMinute = hour * 60 + minute
    let inSecond = inMinute * 60 + second
    this.setTime(this.getTime() + (inSecond*1000))
    return this;
};

/**
 * Add / subtract minute to current date (change this object) and return it.
 * @param {int} minuteNumber. Positive to add and negative to minus
 * @returns {Date}
 */
Date.prototype.addMinute = function (minuteNumber) {
    this.setMinutes(this.getMinutes() + minuteNumber);
    return this;
};

Date.prototype.diff = function (szDateType, otherDate) {
    var inMs = this - otherDate;
    if (szDateType === "yy") {
        return parseInt(inMs / 365 / 24 / 3600 / 1000);
    }
    if (szDateType === "mm") {
        return parseInt(inMs / 30 / 24 / 3600 / 1000);
    }
    if (szDateType === "dd") {
        return parseInt(inMs / 24 / 3600 / 1000);
    }
    if (szDateType === "hh") {
        return parseInt(inMs / 3600 / 1000);
    }
    if (szDateType === "mi") {
        return parseInt(inMs / 60 / 1000);
    }
    if (szDateType === "ss") {
        return parseInt(inMs / 1000);
    }
    return inMs;
};

Date.prototype.diffUntilDay = function(otherDate) {
    var inMs = this - otherDate;
    var result = {};
    result.year = Math.floor(inMs / 365 / 24 / 3600 / 1000);
    inMs = inMs - (result.year * 365 * 24 * 3600 * 1000);
    result.month = 0;
    if (inMs > 0) {
        result.month = Math.floor(inMs / 30 / 24 / 3600 / 1000);
    }
    inMs = inMs - (result.month * 30 * 24 * 3600 * 1000);
    result.day = 0;
    if (inMs > 0) {
        result.day = Math.floor(inMs / 24/ 3600 / 1000);
    }
    return result;
}

/**
 * Compare current date (this object) with other date. Comparison is based on date.
 * @param {Date} otherDate. Other date to compare.
 * @returns {boolean}. True if equal.
 */
Date.prototype.isDateEqual = function (otherDate) {
    return this.compareDate(otherDate) === 0;
};

/**
 * Compare current datetime (this object) with other datetime. Comparison is based on milliseconds.
 * @param {Date} otherDate. Other date to compare.
 * @returns {boolean}. True if equal.
 */
Date.prototype.isDateTimeEqual = function (otherDate) {
    return this.compareDateTime(otherDate) === 0;
};

/**
 * Compare if current datetime (this object) between or equal with startDate and endDate. Comparison is based on milliseconds.
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {boolean}. True if equal.
 */
Date.prototype.isBetweenTime = function (startDate, endDate) {
    return this.compareDateTime(startDate) >= 0
        && this.compareDateTime(endDate) <= 0;
};

/**
 * Compare if current date (this object) between or equal with startDate and endDate. Comparison is based on date.
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {boolean}. True if equal.
 */
Date.prototype.isBetween = function (startDate, endDate) {
    return this.compareDate(startDate) >= 0
        && this.compareDate(endDate) <= 0;
};

/**
 * Compare current datetime (this object) with other datetime. Comparison is based on milliseconds.
 * @param {Date} otherDate. Other datetime to compare.
 * @returns {int}. 0 --> equal, 1 --> this object > otherDate, -1 --> this object < otherDate.
 */
Date.prototype.compareDateTime = function (otherDate) {
    if (this.getTime() === otherDate.getTime()) {
        return 0;
    }
    if (this.getTime() > otherDate.getTime()) {
        return 1;
    }
    return -1;
};

/**
 * Compare current date (this object) with other date. Comparison is based on date.
 * @param {Date} otherDate. Other date to compare.
 * @returns {int}. 0 --> equal, 1 --> this object > otherDate, -1 --> this object < otherDate.
 */
Date.prototype.compareDate = function (otherDate) {
    if (this.getDate() === otherDate.getDate()
            && this.getMonth() === otherDate.getMonth()
            && this.getFullYear() === otherDate.getFullYear()) {
        return 0;
    }
    if (this.getTime() > otherDate.getTime()) {
        return 1;
    }
    return -1;
};

Date.toServerStr = function(date) {
    if (jng.isUndefined(date)) return ''
    if (jng.isDate(date)) {
        return date.toServerStr()
    } else if (jng.isString(date)) {
        if (date == '') return ''
        return (new Date(date)).toServerStr()
    } else {
        return (new Date(date)).toServerStr()
    }
};
Date.toServerLong = function(date) {
    if (jng.isDate(date)) {
        return date.getTime()
    } else if (jng.isString(date)) {
        return (new Date(date)).getTime()
    } else {
        return date
    }
};
Date.prototype.toServerStr = function () {
    return Date.toDateString(this);
};

Date.prototype.toControlValue = function () {
    return Date.toDateString(this);
};

Date.convertFromStr = function (str, format, delimiter) {
    try{
        var formatParts = format.split(' ')
        var dateFormatParts = formatParts[0].split(delimiter)
        var timeParts = str.split(' ');
        var dateParts = timeParts[0].split(delimiter);
        var hour = 0;
        var min = 0;
        var sec = 0;
        if (timeParts.length > 1) {
            var detTimeParts = timeParts[1].split(":");
            hour = parseInt(detTimeParts[0]);
            min = parseInt(detTimeParts[1]);
            sec = parseInt(detTimeParts[2]);
        }
        if (dateParts.length != 3) return undefined
        if (dateFormatParts.length != 3) return undefined

        var day = 0
        var month = 0
        var year = 0
        for(let i = 0; i < dateFormatParts.length; i++) {
            if (dateFormatParts[i].toLowerCase() == 'dd') {
                day = dateParts[i]
            } else if (dateFormatParts[i].toLowerCase() == 'mm') {
                month = dateParts[i]
            } else {
                year = dateParts[i]
            }
        }
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), hour, min, sec);
    } catch (e){
        return undefined;
    }
};

Date.fromServerStr = function (str) {
    try{
        var timeParts = str.split(' ');
        var dateParts = timeParts[0].split('-');
        var hour = 0;
        var min = 0;
        var sec = 0;
        if (timeParts.length > 1) {
            var detTimeParts = timeParts[1].split(":");
            hour = parseInt(detTimeParts[0]);
            min = parseInt(detTimeParts[1]);
            sec = parseInt(detTimeParts[2]);
        }
        return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), hour, min, sec);
    } catch (e){
        return undefined;
    }
};

/**
 * Set only minute and second of current date (change this object). Year, month, date, and hour is remain not change.
 * @param {int} minute.
 * @param {int} second. Optional.
 */
Date.prototype.resetMinute = function (minute, second) {
    this.setMinutes(minute);
    if (jng.isDefined(second)) {
        this.setSeconds(second);
    }
};

/**
 * Set only time of current date (change this object). Year, month, and date is remain not change.
 * @param {int} hour
 * @param {int} minute
 * @param {int} second
 */
Date.prototype.resetTime = function (hour, minute, second) {
    this.setHours(hour);
    this.resetMinute(minute, second);
};

/**
 * Set time of otherDate to current date (change this object). Time is hour, minute, second.
 * @param {Date} otherDate.
 */
Date.prototype.resetTimeByDate = function (otherDate) {
    this.resetTime(otherDate.getHours(), otherDate.getMinutes(), otherDate.getSeconds());
};

/**
 * Get current day name.
 * @returns {string}
 */
Date.prototype.getDayName = function () {
    return Date.getDayName(this.getDay());
};

Date.prototype.getMonthName = function () {
    return Date.getMonthName(this.getMonth() + 1);
};
Date.prototype.getAbbrMonthName = function () {
    return Date.getAbbrMonthName(this.getMonth() + 1);
};

/**
 * Check whether this date is valid date or not.
 * @returns {boolean}. True if valid.
 */
Date.prototype.valid = function () {
    return !isNaN(this.getDate());
};

Date.prototype.clone = function () {
    return new Date(this.getTime());
};

Date.getMonth = function(date) {
    if (jng.isUndefined(date)) {
        return (new Date()).getMonth() + 1;
    }
    return date.getMonth() + 1;
};

Date.getYear = function(date) {
    if (jng.isUndefined(date)) {
        return (new Date()).getFullYear();
    }
    return date.getFullYear();
};

Date.setToServerStr = function(objOrArr, propNameOrArr) {
    function setToServerStr(obj, propName) {
        var value = jng.getValueOfObject(obj, propName);
        if (jng.isDate(value)) {
            jng.setValueOfObject(obj, propName, Date.toServerStr(value));
        }
    }

    if (jng.isArray(objOrArr)) {
        for(var i = 0; i < objOrArr.length; i++) {
            Date.setToServerStr(objOrArr[i], propNameOrArr);
        }
    } else {
        if (jng.isArray(propNameOrArr)) {
            for(var i = 0; i < propNameOrArr.length; i++) {
                Date.setToServerStr(objOrArr, propNameOrArr[i]);
            }
        } else {
            setToServerStr(objOrArr, propNameOrArr)
        }
    }
};
Date.setToMilis = function(objOrArr, propNameOrArr) {
    function setMilis(obj, propName) {
        var value = jng.getValueOfObject(obj, propName);
        if (jng.isDate(value)) {
            jng.setValueOfObject(obj, propName, value.getTime());
        }
    }

    //BEGIN
    if (jng.isArray(objOrArr)) {
        for(var i = 0; i < objOrArr.length; i++) {
            Date.setToMilis(objOrArr[i], propNameOrArr);
        }
    } else {
        if (jng.isArray(propNameOrArr)) {
            for(var i = 0; i < propNameOrArr.length; i++) {
                Date.setToMilis(objOrArr, propNameOrArr[i]);
            }
        } else {
            setMilis(objOrArr, propNameOrArr);
        }
    }
};
Date.convertToDate = function(value) {
    if (!jng.isDate(value)) {
        if (!jng.isString(value)) {
            return new Date(value)
        } else {
            return Date.fromServerStr(value)
        }
    }
    return value
}
Date.setToDate = function(objOrArr, propNameOrArr) {
    function setDate(obj, propName) {
        var value = jng.getValueOfObject(obj, propName);
        if (!jng.isDate(value)) {
            if (!jng.isString(value)) {
                jng.setValueOfObject(obj, propName, new Date(value));
            } else {
                jng.setValueOfObject(obj, propName, Date.fromServerStr(value));
            }

        }
    }

    //BEGIN
    if (jng.isArray(objOrArr)) {
        for(var i = 0; i < objOrArr.length; i++) {
            Date.setToDate(objOrArr[i], propNameOrArr);
        }
    } else {
        if (jng.isArray(propNameOrArr)) {
            for(var i = 0; i < propNameOrArr.length; i++) {
                Date.setToDate(objOrArr, propNameOrArr[i]);
            }
        } else {
            setDate(objOrArr, propNameOrArr);
        }
    }
};

/**
 * Get month number of middle date between startDate and endDate. Middle date = startDate  - endDate / 2
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {int}
 */
Date.getMonthOfMiddleDate = function (startDate, endDate) {
    var intervalInMs, middleDate;
    intervalInMs = (endDate.getTime() - startDate.getTime()) / 2;
    middleDate = new Date(startDate);
    middleDate.setMilliseconds(middleDate.getMilliseconds() + intervalInMs);
    return middleDate.getMonth();
};

/**
 * Get 3 character of month name.
 * @param {int} monthNum. Start from 0 (0 for January) till 11 (for December)
 * @returns {string}
 */
Date.getAbbrMonthName = function (monthNum) {
    var monthName = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DES"];
    return monthName[monthNum - 1];
};

Date.getMonthName = function (monthNum) {
    var monthName = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    return monthName[monthNum - 1];
};

Date.getMonthNameInEnglish = function (monthNum) {
    var monthName = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return monthName[monthNum - 1];
};

/**
 * Get first date of month from date parameter. Year, month are same with date parameter and date equal to 1.
 * @param {Date} date. Example 2014-01-06
 * @returns {Date}. Example 2014-01-01
 */
Date.getFirstDateOfMonth = function (date) {
    var yearNum, monthNum;
    yearNum = date.getFullYear();
    monthNum = date.getMonth();
    return new Date(yearNum, monthNum, 1);
};

/**
 * Get last date of month from date parameter. Year, month are same with date parameter and date equal to last date of it's month.
 * @param {Date} date. Example 2014-01-06
 * @returns {Date}. Example 2014-01-31
 */
Date.getLastDateOfMonth = function (date) {
    var yearNum, monthNum, result;
    yearNum = date.getFullYear();
    monthNum = date.getMonth();
    result = new Date(yearNum, monthNum + 1, 1);
    result.addDay(-1);
    return result;
};

/**
 * Get first date of week. First date of week is always Sunday of that week.
 * @param {int} yearNum. Year number example 2014.
 * @param {int} weekNum. Week number example 1.
 * @returns {Date}. Example will return 2014-01-01 (first date of week 1 in year 2014)
 */
Date.getFirstDateOfWeek = function (yearNum, weekNum) {
    var result,
        numDays,
        dayOfWeek;

    result = new Date(yearNum, 0, 1);
    if (weekNum === 1) {
        return result;
    }
    numDays = (weekNum - 1) * 7;
    dayOfWeek = result.getDay();
    return result.addDay(numDays - dayOfWeek);
};

/**
 * Get last date of week. Last date of week is always Saturday.
 * @param {int} yearNum. Year number example 2014.
 * @param {int} weekNum. Week number example 1.
 * @returns {Date}. Example will return 2014-01-04 (first date of week 1 in year 2014)
 */
Date.getLastDateOfWeek = function (yearNum, weekNum) {
    var result,
        dayOfWeek,
        firstDate;

    result = new Date(yearNum, 0, 1);
    if (weekNum === 1) {
        dayOfWeek = result.getDay();
        return result.addDay(6 - dayOfWeek);
    }

    firstDate = Date.getFirstDateOfWeek(yearNum, weekNum);
    return firstDate.addDay(6);
};

/**
 * Get week distance between date parameter and first date of month from date parameter. This distance includes current week (week difference + 1)
 * @param {Date} date. Example 2014-01-22
 * @returns {number}. Example 4 ==> 4 (week at 2014-01-22) - 1 (week at 2014-01-01) + 1
 */
Date.getWeekDistanceFromMonth = function (date) {
    var firstDateOnMonth,
        firstWeekNum,
        currWeekNum;

    firstDateOnMonth = Date.getFirstDateOfMonth(date);
    firstWeekNum = firstDateOnMonth.getWeek();
    currWeekNum = date.getWeek();
    return currWeekNum - firstWeekNum + 1;
};

/**
 * Get name of day of week. 0 means Sunday
 * @param {int} dayOfWeek. Example 5
 * @returns {string}. Example "Jumat"
 */
Date.getDayName = function (dayOfWeek) {
    var dayNames = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
    return dayNames[dayOfWeek];
};

Date.getDayNameInEnglish = function (dayOfWeek) {
    var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return dayNames[dayOfWeek];
};

/**
 * Get first character of day of week name. 0 means Sunday.
 * @param {int} dayOfWeek. Example 5
 * @returns {string}. Example "J"
 */
Date.getShortDayName = function (dayOfWeek) {
    var dayNames = ["M", "S", "S", "R", "K", "J", "S"];
    return dayNames[dayOfWeek];
};

Date.getMinDate = function() {
    return Date.createDate(1900, 1, 1);
};

Date.isDefaultDate = function(date) {
    if (jng.isUndefined(date)) return true
    if (!jng.isDate(date)) date = new Date(date)
    return date.compareDate(Date.getMinDate()) === 0 ||
            date.compareDate(Date.createDate(1970, 1, 1)) === 0 ||
            date.compareDate(Date.createDate(1900, 1, 1)) <= 0;
}

Date.createDateFromYYYYMMDD = function(str) {
    return Date.createDate(str.getPart(0, '-'), str.getPart(1, '-'), str.getPart(2, '-'));
};

Date.createDateFromDDMMYYYY  = function(str) {
    return Date.createDate(str.getPart(2, '-'), str.getPart(1, '-'), str.getPart(0, '-'));
};

Date.replaceIfMinDate = function(date, replaceDate) {
    if (date.compareDate(Date.getMinDate()) == 0) return replaceDate;
    return date;
};

Date.getCurrentYear = function() {
    return (new Date()).getFullYear();
};
/**
 * Get date for first week day of month.
 * @param {number} iYear. Example: 2014
 * @param {number} iMonth. Example: 1
 * @returns {Date}. Example 2013-12-29
 */
Date.getFirstDateOfWeekDay = function (iYear, iMonth) {
    var dtFirst = new Date(iYear, iMonth, 1);
    var iCurrWeekDay = dtFirst.getDay();
    return dtFirst.addDay(iCurrWeekDay * -1);
};

/**
 * Get date for last week day of month
 * @param {number} iYear. Example: 2014
 * @param {number} iMonth. Example: 1
 * @returns {Date}. Example: 2014-02-01
 */
Date.getLastDateOfWeekDay = function (iYear, iMonth) {
    var dtLast = new Date(iYear, iMonth + 1, 1);
    dtLast.addDay(-1);
    var iCurrWeekDay = dtLast.getDay();
    if (iCurrWeekDay === 0) {
        return dtLast;
    }
    return dtLast.addDay(7 - iCurrWeekDay);
};
Date.createDate = function (iYear, iMonth, iDate) {
    var result = new Date();
    result.setDate(iDate);
    result.setMonth(iMonth - 1);
    result.setYear(iYear);
    result.resetTime(0, 0, 0);
    return result;
};

Date.compareTimeInStr = function (szTime1, szTime2) {
    if (szTime1 < szTime2) {
        return -1;
    }
    if (szTime1 === szTime2) {
        return 0;
    }
    return 1;
};

Date.getStrTimeHour = function(szTime) {
    return szTime.substring(0, 2);
}

Date.getStrTimeMinute = function(szTime) {
    return szTime.substring(3, 5);
}

Date.getStrTimeSecond = function(szTime) {
    if (szTime.length > 6) {
        return szTime.substring(6, szTime.length);
    }
    return '00';
}

Date.formatTime = function(szTime) {
    return Date.getStrTimeHour(szTime) + ':' + Date.getStrTimeMinute(szTime);
}

Date.diffTimeInStrInMin = function (szStartTime, szEndTime) {
    function calculateSecond(time) {
        var hour = parseInt(Date.getStrTimeHour(time));
        var minute = parseInt(Date.getStrTimeMinute(time));
        var second = parseInt(Date.getStrTimeSecond(time));
        return hour * 3600 + minute * 60 + second;
    }

    //Begin Code
    var second1 = calculateSecond(szStartTime);
    var second2 = calculateSecond(szEndTime);
    return (second2 - second1) / 60;
};

Date.TIME_COMPARATION_EXCLUDE_TYPE = {
    START: 1,
    END: 2,
    BOTH: 3
};
Date.isTimeOverlapInStr = function (szEvaluateTime, szStartTime, szEndTime, excludeType) {
    if (jng.isDefined(excludeType)) {
        if (excludeType === Date.TIME_COMPARATION_EXCLUDE_TYPE.START) {
            return Date.compareTimeInStr(szEvaluateTime, szStartTime) > 0 && Date.compareTimeInStr(szEvaluateTime, szEndTime) <= 0;
        } else if(excludeType === Date.TIME_COMPARATION_EXCLUDE_TYPE.END) {
            return Date.compareTimeInStr(szEvaluateTime, szStartTime) >= 0 && Date.compareTimeInStr(szEvaluateTime, szEndTime) < 0;
        } else if (excludeType === Date.TIME_COMPARATION_EXCLUDE_TYPE.BOTH) {
            return Date.compareTimeInStr(szEvaluateTime, szStartTime) > 0 && Date.compareTimeInStr(szEvaluateTime, szEndTime) < 0;
        }
    }
    return Date.compareTimeInStr(szEvaluateTime, szStartTime) >= 0 && Date.compareTimeInStr(szEvaluateTime, szEndTime) <= 0;

}
Date.intersactionTimeInStr = function (szStartTime1, szEndTime1, szStartTime2, szEndTime2, excludeType) {
    var excludeTypeStart;
    var excludeTypeEnd;
    if (jng.isDefined(excludeType)) {
        if (excludeType === Date.TIME_COMPARATION_EXCLUDE_TYPE.START) {
            excludeTypeStart = Date.TIME_COMPARATION_EXCLUDE_TYPE.START;
            excludeTypeEnd = Date.TIME_COMPARATION_EXCLUDE_TYPE.END;
        } else if (excludeType === Date.TIME_COMPARATION_EXCLUDE_TYPE.END) {
            excludeTypeStart =  Date.TIME_COMPARATION_EXCLUDE_TYPE.END;
            excludeTypeEnd =  Date.TIME_COMPARATION_EXCLUDE_TYPE.START;
        } else {
            excludeTypeStart =  Date.TIME_COMPARATION_EXCLUDE_TYPE.BOTH;
            excludeTypeEnd =  Date.TIME_COMPARATION_EXCLUDE_TYPE.BOTH;
        }
    }
    if (Date.isTimeOverlapInStr(szStartTime1, szStartTime2, szEndTime2, excludeTypeStart))
        return true;
    if (Date.isTimeOverlapInStr(szEndTime1, szStartTime2, szEndTime2, excludeTypeEnd))
        return true;
    if (Date.isTimeOverlapInStr(szStartTime2, szStartTime1, szEndTime1, excludeTypeStart))
        return true;
    if (Date.isTimeOverlapInStr(szEndTime2, szStartTime1, szEndTime1, excludeTypeEnd))
        return true;
    return false;
};


jng.compareDate = function(date1, date2) {
    var dt1 = date1
    if (!jng.isDate(date1)) {
        dt1 = new Date(date1)
    }
    var dt2 = date2
    if (!jng.isDate(date2)) {
        dt2 = new Date(date2) 
    }
    return dt1.compareDate(dt2)
}

jng.createTime = function(timeName, type){
    jng.allTime = [];
    return jng.addTime(timeName, type);
}
jng.addTime = function(timeName, type){
    let intTime = 1000;
    if(type=="MILLIS"){
        jng.allTime.push({timeName: timeName, timeNum: 0, desc: "in millis", type: type});
        intTime = 1;
    }
    else if(type=="SECOND")jng.allTime.push({timeName: timeName, timeNum: 0, desc: "in second", type: "SECOND"});
    else jng.allTime.push({timeName: timeName, timeNum: 0, desc: "in second", type: "SECOND"});
    let curInterval = setInterval(function(){
        let opt = jng.allTime.findFirst(timeName, "timeName");
        if(opt!=undefined){
            opt.timeNum += 1;
        }
    }, intTime);
    let opt = jng.allTime.findFirst(timeName, "timeName");
    if(opt!=undefined)opt.interval = curInterval;
    return {
        stopTime: function(timeName){
            let opt = jng.allTime.findFirst(timeName, "timeName");
            if(opt!=undefined){
                clearInterval(opt.interval);
                let lastTime = opt.timeNum;
                jng.allTime.deleteFirst(timeName, 'timeName');

                return lastTime;
            }else{
                return 0;
            }
        },
        getCurrentTime: function(timeName){
            let opt = jng.allTime.findFirst(timeName, "timeName");
            if(opt!=undefined)return opt.timeNum;
            else return 0;
        }
    }
};